define('editor/edit/layers/add/overlay/index',['durandal/app', 'plugins/http', 'knockout', 'knockout-mapping'], function (app, http, ko, komapping) {
    var viewmodel = function() {
        var self = this;

        self.overlays = ko.observableArray([]);
        self.selectedOverlay = ko.observable();

        self.activate = function(mapId, cancelFunc) {
            self.mapId = mapId;
            self.exit = cancelFunc;
            self.getOverlays()
                .then(self.processOverlays);
        };

        self.getOverlays = function() {
            var url = '/api/editor/overlays',
                data = {
                    editorMapId: self.mapId
                };

            return http.get(url, data);
        };

        self.processOverlays = function(response) {
            if (response.data) {
                ko.utils.arrayPushAll(self.overlays, response.data.overlays);
                self.selectedOverlay(self.overlays()[0]);
            }
        };

        self.save = function() {
            var url = "/api/editor/layers/add",
                overlay = {
                    url: self.selectedOverlay().baseUrl,
                    options: {
                        layers: self.selectedOverlay().layer,
                        format: 'image/png',
                        transparent: true,
                        opacity: 0.5
                    }
                },
                data = {
                    editorMapId: self.mapId,
                    type: 'Overlay',
                    state: overlay
                };

            return http.post(url, data)
                .then(function(response) {
                    if (response.success) {
                        var layerData = response.data["createdLayer"],
                            layerState = komapping.fromJS(layerData.state),
                            layer = {
                                id: ko.observable(layerData.id),
                                name: ko.observable(layerData.name),
                                groupId: ko.observable(data.groupId),
                                groupName: ko.observable(data.groupName),
                                groupColour: ko.observable(data.groupColour),
                                visible: ko.observable(layerData.visible),
                                type: ko.observable(layerData.type),
                                order: ko.observable(layerData.order),
                                state: ko.observable(layerState)
                            };

                        delete layerState['__ko_mapping__'];

                        app.trigger("layer:new", layer);

                        self.exit();
                    } else {
                        app.showMessage("Failed to add layer", "Add Layer");
                    }
                });
        };
    };

    return viewmodel;
});

